import { render, staticRenderFns } from "./SendEmailDialog.vue?vue&type=template&id=e5209b4a&"
import script from "./SendEmailDialog.vue?vue&type=script&lang=js&"
export * from "./SendEmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports